module.exports = __webpack_public_path__ + "img/snackbar-success.0847c146.svg";